import React from 'react'
import { translate } from 'react-i18next'
import './index.sass'

const InvoiceDetails = ({ t }) => {
  return (
    <div className="invoice-wrapper">
      <div
        className="payment-account"
        dangerouslySetInnerHTML={{ __html: t('payments.invoiceDetails') }}
      ></div>
      <div
        className="payment-account"
        dangerouslySetInnerHTML={{ __html: t('payments.wireTransfer.texts') }}
      ></div>
    </div>
  )
}

export default translate('translations')(InvoiceDetails)
